import ColorBgWithTwoPictures from './color-bg-with-two-pictures';
export default ColorBgWithTwoPictures;
